<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import { required } from "vuelidate/lib/validators";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification";
import CheckModal from "@/components/CheckModal";
import ItemAPI from "@/services/items/itemsAPI";
import accionesCorrectivasPreventivasAPI from "../../../services/standards/accionesCorrectivasPreventiavs/accionesCorrectivasPreventivasAPI";
import employeeAPI from "../../../services/employee/employeeAPI";
/**
 * Form elements component
 */
export default {
  page: {
    title: "7.1.1 Acciones correctivas y/o preventivas",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
  },
  data() {
    return {
      title: "7.1.1 Acciones correctivas y/o preventivas",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Acciones correctivas y/o preventivas",
        },
        {
          text: "Reporte acciones de Promoción y Prevención",
          active: true,
        },
      ],

      lista: [],
      loading: true,
      usersList: [],

      list: [],

      item: null,
      search: "",
      file: null,
      submitted: false,

      itemData: null,

      acciones: {
        detection_date: null,
        area: null,
        action_type: null,
        actual_state: null,
      },

      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
      company: this.$store.getters["company/getCompany"] || null,
      token: this.$store.state.auth.user.token || null,
    };
  },
  validations: {
    acciones: {
      detection_date: {
        required,
      },
      evaluator: {
        required,
      },
      action_type: {
        required,
      },
      actual_state: {
        required,
      },
      corrective_actions_id: {
        required,
      },
      employee_id: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(57)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;

          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },


    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 57)
        .then((response) => {
          this.item = response || null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;

      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty

        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty

        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;

        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );

        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged

      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    getUsers() {
      employeeAPI
        .getEmployeesOcupationalMedical(this.companyID)
        .then((res) => {
          this.usersList = res.employee;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getListA() {
      accionesCorrectivasPreventivasAPI
        .getList()
        .then((response) => {
          this.loading = false;
          this.list = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.loading = false;
        });
    },

    getList() {
      accionesCorrectivasPreventivasAPI
        .getAll(this.companyID)
        .then((response) => {
          this.lista = response.data.data;
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async print() {
      try {
        window.location.href = `https://sst-backend-xf8ho.ondigitalocean.app/api/corrective_actions/excel/${this.companyID}?&access_token=${this.token}&detection_date=${this.acciones.detection_date}&area=${this.acciones.area}&action_type=${this.acciones.action_type}&actual_state=${this.acciones.actual_state}`;
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

  },

  mounted() {
    this.getItems();
    this.getList();
    this.getListA();
    this.getItemData();
    this.getUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      La empresa debe definir e implementar las acciones
                      preventivas y/o correctivas necesarias con base en los
                      resultados de la supervisión, auditorias, inspecciones,
                      medición de los indicadores del Sistema de Gestión de SST,
                      las recomendaciones del COPASST, resultados de la revisión
                      por la Alta Dirección del Sistema de Gestión de SST,
                      resultados de las investigaciones de los accidentes de
                      trabajo, así como de las enfermedades laborales y de
                      requerimientos o recomendaciones de autoridades
                      administrativas y de las administradoras de riesgos
                      laborales, entre otros.
                    </p>
                    <p class="text-justify">
                      Estas acciones se tomarán para prevenir o corregir una
                      posible desviación del SG SST, además será necesario que
                      la empresa realice seguimiento a su implementación, para
                      garantizar el cierre. En los casos de acciones derivadas
                      de auditorías, investigación de accidentes o enfermedades
                      laborales, o incumplimientos repetitivos derivados de las
                      inspecciones, se deberá realizar el respectivo análisis de
                      causas y para esto la empresa utilizará la metodología que
                      desee (árbol de causas, lluvia de ideas, causa – efecto, 5
                      porqué).
                    </p>
                  </CheckModal>
                </div>

                <div class="col-6 text-right m-b-0">
                  <div class="btn btn-secondary m-l-5 ml-1" id="back" @click="goBack">
                    <i class="fas fa-arrow-left"></i>
                  </div>
                  <b-tooltip target="back" placement="left"> Volver </b-tooltip>
                </div>
              </div>

              <hr />
              <form class="form-group" @submit.prevent="save">
                <div class="form-row pt-3">
                  <b-form-group class="col-md-6 px-2" label="Fecha detección" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date"
                      v-model="acciones.detection_date" :class="{
                        'is-invalid':
                          $v.acciones.detection_date.$error && submitted,
                      }">
                      >
                    </b-form-input>
                    <div v-if="submitted && $v.acciones.detection_date.$error">
                      <small v-if="!$v.acciones.detection_date.required" class="text-danger">
                        <b>La fecha de detección es requerida</b>
                      </small>
                    </div>
                  </b-form-group>

                  <b-form-group class="col-md-6 px-2" label="Área" label-for="trainingDate">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="text" maxlength="50"
                      v-model="acciones.area">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Tipo de acción">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="acciones.action_type" :class="{
                        'is-invalid':
                          $v.acciones.action_type.$error && submitted,
                      }">
                      <b-form-select-option value="Preventiva">
                        Preventiva
                      </b-form-select-option>
                      <b-form-select-option value="Correctiva">
                        Correctiva
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.acciones.action_type.$error">
                      <small v-if="!$v.acciones.action_type.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                  <b-form-group label-for="employee" class="col-md-6 px-2 mb-3" label="Estado actual">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="acciones.actual_state" :class="{
                        'is-invalid':
                          $v.acciones.actual_state.$error && submitted,
                      }">
                      <b-form-select-option value="Abierta">
                        Abierta
                      </b-form-select-option>
                      <b-form-select-option value="Cerrada">
                        Cerrada
                      </b-form-select-option>
                    </select>
                    <div v-if="submitted && $v.acciones.actual_state.$error">
                      <small v-if="!$v.acciones.actual_state.required" class="text-danger">
                        <b>El campo es requerido</b>
                      </small>
                    </div>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button @click="print" type="button" :disabled="!getRole('Crear') || !allowAccess()"
                    class="btn btn-primary">
                    Descargar reporte
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>
